import { useEffect, useState } from "react";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { MdOutlineShoppingCart } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../../redux/actions/prodcutAction";
import {fetchCategories} from "../../../redux/actions/categoryActions"
import { toast } from "react-toastify";
import { fetchWishlistData } from "../../../redux/actions/wishlistData";
import { addToWishlist, removeFromWishlist } from "../../../service/addToWishlist";
import { addToCart } from "../../../service/addToCart";
import { fetchCartData } from "../../../redux/actions/cartData";
export default function SectionTwo() {
  const location = useLocation();
  const storedUser = localStorage.getItem("customeruser");
  const [sortOption, setSortOption] = useState("default");
  const [itemsToShow, setItemsToShow] = useState(10);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate=useNavigate();

  const [filterOptions, setFilterOptions] = useState({
    category: "all",
    launchStatus: "all",
    discount: "all",
    minPrice: "",
    maxPrice: ""
  });

  const dispatch=useDispatch();

  const {categories=[]}=useSelector((state)=>state.categoryState);

  const {wishlistData=[], wishlisterror,}=useSelector((state)=>state.wishlistState);

  useEffect(()=>{
    if(categories.length==0){
      dispatch(fetchCategories());
    }
  },[dispatch,categories.length]);

  useEffect(()=>{
      dispatch(fetchWishlistData());
  },[dispatch]);

  useEffect(()=>{
      dispatch(fetchCartData());
  },[dispatch]);


  const { product,totalRecords, error } = useSelector(
    (state) => state.productState
  );

  useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      dispatch(fetchProducts(currentPage, itemsToShow, searchTerm, filterOptions.launchStatus !== "all" ? filterOptions.launchStatus : ""));

    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [dispatch,currentPage, itemsToShow, searchTerm, filterOptions.launchStatus]);

  useEffect(() => {
    if (location.state?.category) {
      console.log("Category id from home page: ",location.state.category)
      setFilterOptions((prev) => ({
        ...prev,
        category: location.state.category
      }));
    }
  }, [location.state]);

 const parsePrice = (price) => {
  if (!price) return 0;

  if (typeof price === "number") return price;

  const cleaned = price.replace(/[₹,]/g, "").trim();
  return parseFloat(cleaned) || 0;
};

  const applyFilters = (items) => {
    return items.filter((item) => {
      const itemPrice = parsePrice(item.discountedPrice);

      const categoryMatch =
        filterOptions.category === "all" ||
        (item.category?.id === Number(filterOptions.category));

      const launchMatch =
        filterOptions.launchStatus === "all" ||
        (item.displaySections?.includes(filterOptions.launchStatus));


      const discountMatch =
        filterOptions.discount === "all" ||
        item.discountPercent >= Number(filterOptions.discount);

      const minPrice =
        filterOptions.minPrice !== "" ? Number(filterOptions.minPrice) : null;
      const maxPrice =
        filterOptions.maxPrice !== "" ? Number(filterOptions.maxPrice) : null;

      const minPriceMatch = minPrice === null || itemPrice >= minPrice;
      const maxPriceMatch = maxPrice === null || itemPrice <= maxPrice;  

      return categoryMatch && launchMatch && discountMatch && minPriceMatch && maxPriceMatch ;
    });
  };

  const handleSearch = (data) => {
  if (!searchTerm.trim()) return data;

  const term = searchTerm.toLowerCase().trim();

  return data.filter((item) => {
    const productNameMatch = item.productName?.toLowerCase().includes(term);
    const modelMatch = item.model?.toLowerCase().includes(term);
    const categoryMatch = item.category?.name?.toLowerCase().includes(term);

    return productNameMatch || modelMatch || categoryMatch;
  });
  };

  const handleSort = (data) => {
    switch (sortOption) {
      case "lowToHigh":
        return [...data].sort((a, b) => parsePrice(a.discountedPrice) - parsePrice(b.discountedPrice));
      case "highToLow":
        return [...data].sort((a, b) => parsePrice(b.discountedPrice) - parsePrice(a.discountedPrice));
      default:
        return data;
    }
  };

  const startIndex = (currentPage - 1) * itemsToShow;
  const visibleData = handleSort(handleSearch(applyFilters(product))); // no slice
  const totalPages = Math.ceil(totalRecords / itemsToShow);

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  const isInWishlist = (productId) => {
    return wishlistData.some(item => item.product.id === productId);
  };

  const toggleWishlist = (productId) => {  
    if (!storedUser) {
      toast.warning("Please login to manage wishlist");
      setTimeout(() => navigate("/login"), 1000);
      return;
    }
    if (isInWishlist(productId)) {
      dispatch(removeFromWishlist(productId));
    } else {
      dispatch(addToWishlist(productId));
    }
  };

  const toggleCart=(productId)=>{
    if (!storedUser) {
      toast.warning("Please login to manage wishlist");
      setTimeout(() => navigate("/login"), 1000);
      return;
    }
    dispatch(addToCart(productId));
  };

 function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
 }

  if (loading) {
    return <p className="text-center mt-10">Loading products...</p>;
  }

  if(error)
  {
    return(
      <p className="text-red-600">product error : {error}</p>
    );
  }

  if(wishlisterror)
  {
    if(storedUser)
    return(
      <p className="text-red-600">Wishlist error : {wishlisterror}</p>
    );
  }

  return (
    <section className="bg-white pb-5 mb-10">
     
      <div className="bg-[#F9F1E7] px-5 md:px-5 py-5 mb-10 flex flex-col lg:flex-row items-start xl:items-center justify-between space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className="border px-4 py-1 font-bold bg-white text-sm xl:text-base rounded flex flex-row items-center space-x-2 hover:text-pink-600 hover:scale-110"
          >
            <HiOutlineAdjustmentsHorizontal className="text-xl" />
            <p>Filter</p>
          </button>
          <p className="text-xs md:text-sm xl:text-base text-gray-700">
          {visibleData.length === 0
            ? "No results found"
            : `Showing ${startIndex + 1} - ${Math.min(startIndex + itemsToShow, visibleData.length)} of ${visibleData.length} results`}
          </p>

        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center space-y-2 md:space-y-0 md:space-x-4 xl:space-x-4">
          <div className="flex items-center space-x-2">
            <label className="text-xs md:text-sm xl:text-base font-medium text-gray-700">Show:</label>
            <select
              value={itemsToShow}
              onChange={(e) => setItemsToShow(Number(e.target.value))}
              className="px-2 py-1 border rounded text-sm"
            >
              {[ 10,20,30, 40].map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-xs md:text-sm xl:text-base font-medium text-gray-700">Sort by:</label>
            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className="px-2 py-1 border rounded text-sm"
            >
              <option value="default">Default</option>
              <option value="lowToHigh">Price: Low to High</option>
              <option value="highToLow">Price: High to Low</option>
            </select>
          </div>

          <div className="flex items-center space-x-2">
            <label className="text-xs md:text-sm xl:text-base font-medium text-gray-700">Search product:</label>
            <input 
              type="text" 
              className="px-2 py-1 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder="Search product"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

        </div>
      </div>

      <div className="flex flex-row items-start">
      {isFilterOpen && (
        <div className="px-3 py-4 border bg-gray-50 mb-8 ml-5 rounded">
          <div className="grid grid-cols-1 gap-y-5">
            <div className="flex flex-col space-y-1 items-start">
              <label className="block font-semibold text-xs md:text-sm xl:text-base">Category</label>
              <select
                value={filterOptions.category}
                onChange={(e) =>
                  setFilterOptions({ ...filterOptions, category: e.target.value })
                }
                className="px-2 py-1 border border-gray-400 rounded w-full focus:border-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="all">All</option>
                {categories.map((item) =>(
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}

              </select>
            </div>

            <div className="flex flex-col space-y-1 items-start">
              <label className="block font-semibold text-xs md:text-sm xl:text-base">Show Only Best Sellers</label>
              <select
                value={filterOptions.launchStatus}
                onChange={(e) =>
                  setFilterOptions({ ...filterOptions, launchStatus: e.target.value })
                }
                className="px-2 py-1 border  border-gray-400 rounded w-full focus:border-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="All">All Sections</option>
                <option value="Bestseller">Bestseller</option>
                <option value="New Arrival">New Arrival</option>
                <option value="Offers & Discount">Offers & Discounts</option>

              </select>
            </div>

            <div className="flex flex-col space-y-1 items-start">
              <label className="block font-semibold text-xs md:text-sm xl:text-base">Discount</label>
              <select
                value={filterOptions.discount}
                onChange={(e) =>
                  setFilterOptions({ ...filterOptions, discount: e.target.value })
                }
                className="px-2 py-1 border border-gray-400 rounded w-full focus:border-none focus:ring-2 focus:ring-blue-400"
              >
                <option value="all">All</option>
                <option value="10">10% & more</option>
                <option value="20">20% & more</option>
                <option value="30">30% & more</option>
                <option value="40">40% & more</option>
              </select>
            </div>

            <div className="flex flex-col space-y-1 items-start">
              <label className="block font-semibold text-xs md:text-sm xl:text-base">Min Price</label>
              <input 
               type="text"
               value={filterOptions.minPrice}
               onChange={(e) =>
                  setFilterOptions({ ...filterOptions, minPrice: e.target.value })
                }
                className="px-2 py-1 border border-gray-400 rounded w-full focus:border-none focus:ring-2 focus:ring-blue-400"
              />
              
            </div>

            <div className="flex flex-col space-y-1 items-start">
              <label className="block font-semibold text-xs md:text-sm xl:text-base">Max Price</label>
              <input 
               type="text"
                value={filterOptions.maxPrice}
                onChange={(e) =>
                  setFilterOptions({ ...filterOptions, maxPrice: e.target.value })
                }
                className="px-2 py-1 border border-gray-400 rounded w-full focus:border-none focus:ring-2 focus:ring-blue-400"
              />
              
            </div>
          </div>

          <div className="mt-4 flex flex-col justify-between md:justify-end gap-3">
            <button
              onClick={() =>
                setFilterOptions({
                  category: "all",
                  launchStatus: "all",
                  discount: "all",
                  minPrice: "",
                  maxPrice: ""
                },
                setIsFilterOpen(!isFilterOpen))
              }
              className="bg-gray-300 text-black text-xs xl:text-sm font-semibold px-4 py-2 rounded hover:bg-gray-400"
            >
              Clear Filters
            </button>
            <button
              onClick={() => setIsFilterOpen(false)}
              className="bg-pink-600 text-xs xl:text-sm text-white font-semibold px-4 py-2 rounded hover:bg-pink-700"
            >
              Apply Filters
            </button>
          </div>
        </div>
      )}

      <div className="grid gap-x-3 md:gap-x-8 gap-y-7 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 px-5 md:px-10 xl:px-14">
        {visibleData.length === 0 ? (
          <p className="text-center col-span-full text-gray-700 font-semibold py-8">
            No products found matching your filters.
          </p>
        ) : (
          visibleData.map((product, index) => (
             
              <div
                key={index}
                className="rounded-lg shadow bg-gray-100 flex flex-col justify-between pt-2 gap-5"
              >
                
                <div className="relative">
                    <Link to={`/productdetail/${product.id}`}>
                      <img src={product.images?.[0].image} alt={product.productName} className="w-full h-48 object-contain pt-5"/>
                      <div className="absolute top-2 left-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                            {formatNumber(product.discountPercent)}% OFF
                      </div>
                    </Link>
                      <div  onClick={() => toggleWishlist(product.id)}
                          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow cursor-pointer"
                      >
                        {isInWishlist(product.id) ? (
                            <AiFillHeart className="text-xl text-red-600" />
                            ) : (
                            <AiOutlineHeart className="text-xl text-red-600" />
                        )}
                      </div>
                </div>
                
                <div className="flex flex-row space-x-1 rounded-lg justify-between items-center bg-gradient-to-b from-[#E96364] to-[#FEB5B6] p-2 w-full">
                  <div className=" w-[85%]">
                    <Link to={`/productdetail/${product.id}`}>
                    <div className="flex flex-col text-white">
                        <h2 className="flex flex-row items-center gap-1 text-sm md:text-base xl:text-lg font-semibold whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px] md:max-w-[250px] xl:max-w-[220px]">
                            {product.productName} {product.category?.name} {product.model}
                        </h2>
                        <div className="flex flex-row space-x-5 text-sm md:text-base">
                            <p>₹ {formatNumber(product.discountedPrice)}</p>
                            <p className="line-through text-gray-200">
                                ₹ {formatNumber(product.originalPrice)}
                            </p>
                        </div>
                    </div>
                    </Link>
                  </div>
                  <button 
                    className={`bg-white p-2 rounded-full w-auto  ${product.totalStock < 1 ? "cursor-not-allowed bg-opacity-80" : "cursor-pointer"}`}
                    onClick={() => toggleCart(product.id)}
                    disabled={product.totalStock < 1}
                  >
                        <MdOutlineShoppingCart className="text-xl text-red-700" />                       
                  </button>
                </div>
              </div>
            
          ))
        )}
      </div>
      </div>


{totalPages > 1 && (
  <div className="flex justify-center items-center gap-2 mt-10 flex-wrap">
    <button
      onClick={() => setCurrentPage(1)}
      disabled={currentPage === 1}
      className="px-2 py-1 text-sm font-bold text-black rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
    >
      {"<<"}
    </button>
    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className="px-2 py-1 text-sm font-bold text-black rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
    >
      {"<"}
    </button>

    {Array.from({ length: totalPages }, (_, i) => i + 1)
      .filter((page) =>
        page === 1 || 
        page === totalPages || 
        Math.abs(currentPage - page) <= 1 ||
        (currentPage <= 1 && page <= 2) ||
        (currentPage >= totalPages - 1 && page >= totalPages - 2) 
      )
      .reduce((acc, page, index, arr) => {
        if (index > 0 && page - arr[index - 1] > 1) acc.push("...");
        acc.push(page);
        return acc;
      }, [])
      .map((page, i) =>
        page === "..." ? (
          <span key={`dots-${i}`} className="px-2 py-1 text-sm text-gray-500">...</span>
        ) : (
          <button
            key={page}
            onClick={() => setCurrentPage(page)}
            className={`px-3 py-1 text-sm rounded border font-medium ${
              currentPage === page
                ? "bg-pink-600 text-white"
                : "hover:bg-pink-100"
            }`}
          >
            {page}
          </button>
        )
      )}

    <button
      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      className="px-2 py-1 text-sm font-bold text-black rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
    >
      {">"}
    </button>
    <button
      onClick={() => setCurrentPage(totalPages)}
      disabled={currentPage === totalPages}
      className="px-2 py-1 text-sm font-bold text-black rounded border hover:bg-pink-600 hover:text-white disabled:text-gray-400"
    >
      {">>"}
    </button>
  </div>
)}

    </section>
  );
}
